import WIDGETS from './widgets';

export default {
	name: 'article_manage',
	spacing: 2,
	widgets: [{ content: WIDGETS.ARTICLES_MANAGE, breakpoints: { xs: 12 } }],
};